
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/studio/[projectId]",
      function () {
        return require("private-next-pages/dashboard/studio/[projectId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/studio/[projectId]"])
      });
    }
  